module.exports = __webpack_public_path__ + "static/customization-03dfb21ead3c8824000b174d452c1491.svg";